import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import views from "./views/index";
import store from "./stores/index";
import components from "./components/index";

Object.keys(views).forEach(function(key) {
  Vue.component(key, views[key]);
});
Object.keys(components).forEach(function(key) {
  Vue.component(key, components[key]);
});

const axios = require("axios").create({
  baseURL: "https://prod-q3s5v4pl4q-ue.a.run.app/api/",
  // baseURL: "http://localhost:8080/api/",
});
Vue.prototype.$axios = axios;
window.axios = axios;
var pusher = new Pusher("932f50dd348d1b60b61c", {
  cluster: "us2",
});
window.pusher = pusher;

new Vue({
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
